/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import style from "./style.module.scss";
import Consts from "@/app/csr-src/data/consts/login";
import cookieUtil from "@/utils/cookieUtils";
import { thirdLoginApi } from "@/app/csr-src/apis/login/index";
import { clearUrlExtraParams, getUrlExtraParams } from "@/utils/extUrlParamsUtils";
import UKLoadingIcon from "@/common-components-src/components/UKLoadingIcon";
import UKToast from "@/common-components-src/components/UKToast/index";
import { sendKeyActionTrack as loginSendKeyActionTrack, EXPOSURE_RECORD as LOGIN_EXPOSURE_RECORD } from "@/tracks/25225";

const JDLogin = () => {
  function getUrlParams() {
    const params: any = {};
    const queryString = window.location.search.substring(1);
    const pairs = queryString.split("&");

    pairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      params[decodeURIComponent(key)] = decodeURIComponent(value || "");
    });
    return params;
  }
  const hasFetched = React.useRef(false);

  React.useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      init();
    }
  }, []);

  const init = React.useCallback(async () => {
    const { code, state } = getUrlParams();
    if (!code) {
      window.location.href = "/";
    }
    const [err, res]: any = await thirdLoginApi({
      code,
      state,
      loginType: Consts.LoginTypeEnum.JD,
    });
    const returnUrl = decodeURIComponent(res?.data?.finalRedirectUrl);
    if (res && res.success) {
      // 登录成功后调用删除clearUrlExtraParams
      clearUrlExtraParams();

      loginSendKeyActionTrack.NewLogin_LoginResult({ loginRegisterType: "6", isNew: res?.authnRegister ? "1" : "0", is_success: res?.success ? "1" : "0" });
      const returnUrl = decodeURIComponent(res?.data?.finalRedirectUrl) || "/";
      cookieUtil.deleteCookie(Consts.LOGIN.USER_SUCCESS_ACCOUNT);
      window.location.href = returnUrl;
    } else {
      UKToast.show({
        icon: "error",
        content: res.msg || "Login error",
      });
      setTimeout(() => {
        location.href = `/`;
      }, 3000);
    }
  }, []);

  return (
    <div className={style.jdLogin}>
      <div className={style.header}>
        <img src="https://st.joy-sourcing.com/website/other/newlogo.jpeg" alt="JoyBuy" />
        <div className={style.header_title}>
          {/* <GreenLock /> */}
          <span>Data encryption</span>
        </div>
      </div>
      <div className={style.content}>
        <UKLoadingIcon type="black" className={style.loadingIcon} />
        <span>JINGDONG Loading...</span>
      </div>
    </div>
  );
};

export default JDLogin;
